import { render, staticRenderFns } from "./OurHeroes.vue?vue&type=template&id=84249886&scoped=true&"
import script from "./OurHeroes.vue?vue&type=script&lang=js&"
export * from "./OurHeroes.vue?vue&type=script&lang=js&"
import style0 from "./OurHeroes.vue?vue&type=style&index=0&id=84249886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84249886",
  null
  
)

export default component.exports